(function() { module.exports = this["wp"]["blocks"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","blocks"]}
// module id = 113
// module chunks = 0